module.exports = __webpack_public_path__ + "img/selected1-min.e8173cdd.png";